__turbopack_context__.v({
  "acheivername": "upsc-environment-book-module__j5iv2q__acheivername",
  "acheiverrank": "upsc-environment-book-module__j5iv2q__acheiverrank",
  "bgbox": "upsc-environment-book-module__j5iv2q__bgbox",
  "bground": "upsc-environment-book-module__j5iv2q__bground",
  "bluetxt": "upsc-environment-book-module__j5iv2q__bluetxt",
  "btnbox": "upsc-environment-book-module__j5iv2q__btnbox",
  "captcha": "upsc-environment-book-module__j5iv2q__captcha",
  "cardBox": "upsc-environment-book-module__j5iv2q__cardBox",
  "cardBox1": "upsc-environment-book-module__j5iv2q__cardBox1",
  "checkboxcontent": "upsc-environment-book-module__j5iv2q__checkboxcontent",
  "contactheader": "upsc-environment-book-module__j5iv2q__contactheader",
  "customFileUploader": "upsc-environment-book-module__j5iv2q__customFileUploader",
  "formstar": "upsc-environment-book-module__j5iv2q__formstar",
  "heading3d": "upsc-environment-book-module__j5iv2q__heading3d",
  "input-group-btn": "upsc-environment-book-module__j5iv2q__input-group-btn",
  "invalidCheck2": "upsc-environment-book-module__j5iv2q__invalidCheck2",
  "normalbutton": "upsc-environment-book-module__j5iv2q__normalbutton",
  "pagemaintitle": "upsc-environment-book-module__j5iv2q__pagemaintitle",
  "redbtn": "upsc-environment-book-module__j5iv2q__redbtn",
  "section1bgbox": "upsc-environment-book-module__j5iv2q__section1bgbox",
  "section1title": "upsc-environment-book-module__j5iv2q__section1title",
  "sectionsubtitle": "upsc-environment-book-module__j5iv2q__sectionsubtitle",
  "sectiontitle": "upsc-environment-book-module__j5iv2q__sectiontitle",
  "selected": "upsc-environment-book-module__j5iv2q__selected",
});
